import IS_SERVER from '@/constants/isServer';
import { getDeviceId, getGAClientId, getGASessionId } from '@/utils/amplitude';

export const isInternalUrl = (host: string): boolean => {
  if (!IS_SERVER) {
    return host === window.location.host;
  }

  return false;
};

export const isExternalUrl = (host: string): boolean => {
  return !!host && !isInternalUrl(host);
};

export const getTrackingParams = (url: string): Record<string, string> => {
  const trackingParams: Record<string, string> = {};
  const keysToExtract = ['fbid', 'gcid'];

  try {
    const parsedUrl = new URL(url);
    const searchParams = parsedUrl.searchParams;

    for (const [key, value] of searchParams.entries()) {
      if (key.toLowerCase().startsWith('utm_') || keysToExtract.includes(key)) {
        trackingParams[key] = value;
      }
    }

    trackingParams['gaClientId'] = getGAClientId();
    trackingParams['gaSessionId'] = getGASessionId();
    trackingParams['amplitudeDeviceId'] = getDeviceId();
  } catch (e) {
    console.warn('Invalid URL:', url);
  }

  return trackingParams;
};
